var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 40.5168C15.3242 41.1424 15.3911 42.0898 16.0168 42.6328C16.6424 43.1758 17.5898 43.1089 18.1328 42.4832L15.8672 40.5168ZM41.4963 14.8942C41.4378 14.0678 40.7206 13.4453 39.8942 13.5037L26.4278 14.4559C25.6015 14.5143 24.9789 15.2316 25.0374 16.058C25.0958 16.8843 25.8131 17.5069 26.6394 17.4484L38.6095 16.6021L39.4559 28.5722C39.5143 29.3985 40.2316 30.0211 41.058 29.9626C41.8843 29.9042 42.5069 29.1869 42.4484 28.3606L41.4963 14.8942ZM18.1328 42.4832C22.6239 37.3088 28.3739 30.6838 33.0011 25.3524C35.3147 22.6867 37.3477 20.3444 38.8022 18.6685C39.5294 17.8306 40.1121 17.1593 40.513 16.6974C40.7134 16.4665 40.8683 16.2879 40.9732 16.1671C41.0256 16.1067 41.0655 16.0607 41.0923 16.0299C41.1057 16.0144 41.1159 16.0028 41.1226 15.995C41.126 15.991 41.1285 15.9881 41.1303 15.9862C41.1311 15.9852 41.1318 15.9844 41.1322 15.9839C41.1324 15.9837 41.1326 15.9835 41.1327 15.9834C41.1328 15.9833 41.1328 15.9832 40 15C38.8672 14.0168 38.8671 14.0169 38.867 14.017C38.8669 14.0171 38.8667 14.0173 38.8665 14.0175C38.8661 14.018 38.8655 14.0188 38.8646 14.0197C38.8629 14.0217 38.8603 14.0247 38.857 14.0285C38.8502 14.0363 38.8401 14.048 38.8267 14.0634C38.7999 14.0943 38.76 14.1403 38.7076 14.2007C38.6027 14.3215 38.4477 14.5001 38.2473 14.731C37.8464 15.1928 37.2638 15.8642 36.5365 16.7021C35.082 18.378 33.0491 20.7203 30.7354 23.386C26.1082 28.7173 20.3582 35.3423 15.8672 40.5168L18.1328 42.4832Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button-arrow.1b60b64c87665d63cf951781b828382a.svg";
export { ForwardRef as ReactComponent };